export function validateCvv(cvv) {
  cvv = cvv.trim();
  return cvv && (cvv.length === 3 || cvv.length === 4);
}
export function validateCardHolder(cardHolder) {
  return cardHolder && cardHolder.length > 2;
}
